var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "shortsPlatform"
  }, [_c("section", {
    style: {
      background: `url(${_vm.imageUrl}) no-repeat center 0px`,
      backgroundSize: "cover"
    }
  }, [_c("Banner", {
    attrs: {
      imageUrl: _vm.imageUrl,
      title: _vm.bannerTitle,
      description: _vm.bannerText
    }
  })], 1), _c("Advantages", {
    attrs: {
      adslist: _vm.adsList
    }
  }), _c("section", {
    staticClass: "function"
  }, [_c("div", {
    staticClass: "function-main"
  }, [_c("Title", {
    attrs: {
      title: "产品功能"
    }
  }), _c("div", {
    staticClass: "list"
  }, _vm._l(_vm.solutionsList, function (item, index) {
    return _c("Card", {
      key: index,
      attrs: {
        title: item.title,
        desc: item.desc,
        img: item.img
      }
    });
  }), 1)], 1)]), _c("ApplicationScenario"), _c("CustomCases"), _c("Appointment2")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };